import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { SprintWebSocketProvider } from './context/SprintWebSocketContext';
import JourneySelectionPage from './screens/JourneySelectionPage';
import LessonPage from './screens/LessonPage';

const SharpSprintRouter: React.FC = () => {
  return (
    <SprintWebSocketProvider>
      <Routes>
        <Route path="" element={<JourneySelectionPage />} />
        <Route path="lesson/:lessonId" element={<LessonPage />} />
        <Route path="journey/:journeyId/lesson/:lessonId" element={<LessonPage />} />
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </SprintWebSocketProvider>
  );
};

export default SharpSprintRouter;
